import { render, staticRenderFns } from "./DetailButton.vue?vue&type=template&id=318ce62c"
import script from "./DetailButton.vue?vue&type=script&lang=js"
export * from "./DetailButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports